import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from '../../contexts/AuthContext';
import { Save } from 'lucide-react';

export const FooterManager = () => {
  const { getAuthHeader } = useAuth();
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [formData, setFormData] = useState({
    tagline: '',
    copyright_text: '',
    distributor_button_text: '',
    disclaimer_text: '',
    amazon_link: '',
  });

  const API_URL = process.env.REACT_APP_BACKEND_URL;

  useEffect(() => {
    fetchFooter();
  }, []);

  const fetchFooter = async () => {
    try {
      const response = await axios.get(`${API_URL}/api/footer`);
      setFormData(response.data);
    } catch (error) {
      console.error('Error fetching footer:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await axios.put(`${API_URL}/api/footer`, formData, {
        headers: getAuthHeader(),
      });
      alert('Footer updated successfully!');
    } catch (error) {
      console.error('Error updating footer:', error);
      alert('Failed to update footer');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return <div className="text-white">Loading...</div>;
  }

  return (
    <div className="max-w-4xl">
      <form onSubmit={handleSubmit} className="space-y-6">
        <div className="bg-gray-800 border border-gray-700 rounded-lg p-6">
          <h3 className="text-xl font-bold text-white mb-4">Footer Content</h3>

          <div className="space-y-4">
            <div>
              <label className="block text-white text-sm font-medium mb-2">
                Tagline
              </label>
              <input
                type="text"
                value={formData.tagline}
                onChange={(e) =>
                  setFormData({ ...formData, tagline: e.target.value })
                }
                className="w-full px-3 py-2 bg-gray-700 border border-gray-600 rounded text-white focus:outline-none focus:ring-2 focus:ring-orange-500"
                placeholder="Premium card protection for serious players"
              />
            </div>

            <div>
              <label className="block text-white text-sm font-medium mb-2">
                Copyright Text
              </label>
              <input
                type="text"
                value={formData.copyright_text}
                onChange={(e) =>
                  setFormData({ ...formData, copyright_text: e.target.value })
                }
                className="w-full px-3 py-2 bg-gray-700 border border-gray-600 rounded text-white focus:outline-none focus:ring-2 focus:ring-orange-500"
                placeholder="© 2024 Planeskeeper. All rights reserved."
              />
            </div>

            <div>
              <label className="block text-white text-sm font-medium mb-2">
                Distributor Button Text
              </label>
              <input
                type="text"
                value={formData.distributor_button_text}
                onChange={(e) =>
                  setFormData({ ...formData, distributor_button_text: e.target.value })
                }
                className="w-full px-3 py-2 bg-gray-700 border border-gray-600 rounded text-white focus:outline-none focus:ring-2 focus:ring-orange-500"
                placeholder="Become a Distributor"
              />
            </div>

            <div>
              <label className="block text-white text-sm font-medium mb-2">
                Amazon Shop Link
              </label>
              <input
                type="url"
                value={formData.amazon_link}
                onChange={(e) =>
                  setFormData({ ...formData, amazon_link: e.target.value })
                }
                className="w-full px-3 py-2 bg-gray-700 border border-gray-600 rounded text-white focus:outline-none focus:ring-2 focus:ring-orange-500"
                placeholder="https://amazon.com/your-store"
              />
              <p className="text-gray-400 text-xs mt-1">
                Link for "Buy on Amazon" in the footer Shop section
              </p>
            </div>

            <div>
              <label className="block text-white text-sm font-medium mb-2">
                Disclaimer Text (Optional)
              </label>
              <textarea
                value={formData.disclaimer_text}
                onChange={(e) =>
                  setFormData({ ...formData, disclaimer_text: e.target.value })
                }
                className="w-full px-3 py-2 bg-gray-700 border border-gray-600 rounded text-white focus:outline-none focus:ring-2 focus:ring-orange-500"
                rows="3"
                placeholder="Legal disclaimer text to display below copyright (optional)"
              />
            </div>
          </div>
        </div>

        <button
          type="submit"
          disabled={saving}
          className="flex items-center px-6 py-3 bg-orange-600 text-white rounded-lg hover:bg-orange-700 disabled:opacity-50"
        >
          <Save className="w-5 h-5 mr-2" />
          {saving ? 'Saving...' : 'Save Changes'}
        </button>
      </form>
    </div>
  );
};
